import cookie from 'js-cookie';

class AccessibilityBar {
  constructor(selector) {
    this.elm = document.querySelector(selector);
    this.context = document.body;

    this.decBtn = this.elm.querySelector('[data-accessibility-bar-dec]');
    this.incBtn = this.elm.querySelector('[data-accessibility-bar-inc]');
    this.conBtn = this.elm.querySelector('[data-accessibility-bar-con]');

    this.setupListeners();
    this.applyInitialState();
  }

  applyInitialState() {
    const isIncreased = cookie.get('increased-font');
    const isContrast = cookie.get('contrast-theme');

    if (isIncreased) {
      this.context.classList.add('increased-font');
    }

    if (isContrast) {
      this.context.classList.add('contrast-theme');
    }
  }

  setupListeners() {
    this.decBtn.addEventListener('click', this.onDecBtnClick.bind(this));
    this.incBtn.addEventListener('click', this.onIncBtnClick.bind(this));
    this.conBtn.addEventListener('click', this.onConBtnClick.bind(this));
  }

  onDecBtnClick() {
    this.context.classList.remove('increased-font');
    cookie.remove('increased-font');
  }

  onIncBtnClick() {
    this.context.classList.add('increased-font');
    cookie.set('increased-font', 'increased-font');
  }

  onConBtnClick() {
    if (this.context.classList.contains('contrast-theme')) {
      document.body.classList.remove('contrast-theme');
      cookie.remove('contrast-theme');
    } else {
      document.body.classList.add('contrast-theme');
      cookie.set('contrast-theme', 'contrast-theme');
    }
  }
}

export default {
  create(selector) {
    return new AccessibilityBar(selector);
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/AccessibilityBar.js